class NewsletterPopup extends ModalDialog {
  constructor() {
    super();
    this.init();
    this.attachEventListeners();
  }

  // Moved all event listeners to a separate method for better organization
  attachEventListeners() {
    this.buttonClose = this.querySelector(".js-button-close");
    this.buttonClose.addEventListener("click", this.closeNewsletter.bind(this));

    if (this.form) {
      this.form.addEventListener("submit", this.onSubscribe.bind(this));
    }
  }

  init() {
    this.delay = this.dataset.delay * 1000;
    this.closed = getCookie("newsletter-closed");
    this.subscribed = getCookie("newsletter-subscribed");
    this.form = this.querySelector(".js-form");
    this.ageVerificationPopup = document.querySelector("age-verification-popup");
  }

  closeNewsletter() {
    setCookie("newsletter-closed", "true");
    this.hide();
  }

  connectedCallback() {
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") {
      this.show();
      }
      return;
    }

    this.handlePopupVisibility();
  }

  handlePopupVisibility() {
    if (getCookie("age-verified") !== "true" && this.ageVerificationPopup) {
      this.handleAgeVerificationPopup();
    } else {
      this.showPopupWithDelay();
    }
  }

  handleAgeVerificationPopup() {
    let prevClassState = this.classList.contains("newsletter-popup-is-hidden");

    const observer = new MutationObserver(mutations => {
      const mutation = mutations[0];
      if (mutation.attributeName !== "class") return;

      const currentClassState = mutation.target.classList.contains("newsletter-popup-is-hidden");

      if (prevClassState !== currentClassState) {
        prevClassState = currentClassState;
        if (!currentClassState) {
          this.showPopupWithDelay();
        }
      }
    });

    observer.observe(this, { attributes: true });
  }

  showPopupWithDelay() {
    setTimeout(() => {
      if (this.closed !== "true" && this.subscribed !== "true") {
        this.show();
      }
    }, this.delay);
  }

  onSubscribe() {
    setCookie("newsletter-subscribed", "true");
    this.hide();
  }
}

/* === MATHO first15 INICIO (Alice 2026-09-22, scripts/popup_first15.py) === */
/*
  Pop-up "Unlock 15% off your first order" (codigo FIRST15):
  - una vez: al cerrarlo de cualquier forma (X, No thanks, Escape, tocando fuera) no vuelve por 14 dias;
    despues de dejar el email, nunca mas (365 dias). Sin cookies no aparece (volveria en cada pagina);
  - SEO (Core Web Vitals): ademas del delay, espera a que la persona se mueva por la pagina (rueda, dedo o
    teclado; un clic cuenta pero no lo abre en ese instante). Chrome deja de medir el LCP en la primera
    interaccion, asi que la foto del pop-up nunca pasa a ser el "Largest Contentful Paint". Medido el 22/9 en la
    copia: sin esto, en /collections/feizy (1280x800, sin tocar nada) el LCP pasaba a la foto del pop-up a los 14 s;
  - al enviar, el formulario sigue su camino normal (POST a /contact y recarga con ?customer_posted=true#<id>).
    Al volver, el pop-up se abre solo con el codigo. Si Shopify contesta que el email ya existe, tambien.
    Si hay otro error (email invalido), se abre el formulario con el error para corregirlo;
  - la foto y el logo se descargan recien la primera vez que se abre (clase matho-f15--visto).
  Para quitarlo: python scripts/popup_first15.py --revertir --tema=<id>
*/
(() => {
  const P = NewsletterPopup.prototype;
  const mostrarTema = P.show;
  const ocultarTema = P.hide;
  const DIAS_CERRADO = 14;
  const DIAS_SUSCRIPTO = 365;
  const ENVIO = "matho-first15-enviado";

  const hayEnvio = () => getCookie(ENVIO) === "1";
  const marcarEnvio = () => { document.cookie = ENVIO + "=1; max-age=1800; path=/; samesite=lax"; };
  const borrarEnvio = () => { document.cookie = ENVIO + "=; max-age=0; path=/; samesite=lax"; };
  // si el foco no entra en el momento (el pop-up todavia no termino de mostrarse), se reintenta en el cuadro siguiente
  const enfocar = el => {
    if (!el) return;
    el.focus({ preventScroll: true });
    if (document.activeElement !== el) requestAnimationFrame(() => el.focus({ preventScroll: true }));
  };
  // Al volver de enviar, la direccion trae el #id del formulario y, al terminar de cargar, el navegador lleva el
  // foco a ese destino (como no es enfocable, cae en la pagina): el pop-up lo pierde. Se le devuelve despues de la
  // carga, solo si quedo en la nada (si la persona ya hizo clic en otro lado, no se le discute).
  const enfocarAlCargar = (popup, el) => {
    if (!el) return;
    enfocar(el);
    const devolver = () => {
      const a = document.activeElement;
      if (popup.hasAttribute("open") && (!a || a === document.body || a === document.documentElement)) enfocar(el);
    };
    // hasta 1 s despues de la carga: si el foco sale del pop-up hacia ningun control, vuelve
    let hasta = Infinity;
    const guardia = evento => {
      if (Date.now() > hasta || !popup.hasAttribute("open")) return popup.removeEventListener("focusout", guardia);
      if (!evento.relatedTarget) setTimeout(devolver, 0);
    };
    popup.addEventListener("focusout", guardia);
    const alCargar = () => {
      hasta = Date.now() + 1000;
      [60, 600].forEach(ms => setTimeout(devolver, ms));
    };
    if (document.readyState === "complete") alCargar();
    else addEventListener("load", alCargar, { once: true });
  };

  P.init = function () {
    this.delay = this.dataset.delay * 1000;
    this.closed = getCookie("newsletter-closed");
    this.subscribed = getCookie("newsletter-subscribed");
    this.form = this.querySelector(".js-form");
    this.ageVerificationPopup = document.querySelector("age-verification-popup");
    this.panelOk = this.querySelector("[data-matho-f15-ok]");
  };

  P.attachEventListeners = function () {
    // "No thanks" ya lo cierra ModalDialog (id ModalClose-...); aca la X y "Start shopping"
    this.querySelectorAll("[data-matho-f15-cerrar]").forEach(boton => boton.addEventListener("click", () => this.hide()));
    if (this.form) this.form.addEventListener("submit", this.onSubscribe.bind(this));
    const copiar = this.querySelector("[data-matho-f15-copiar]");
    if (copiar) copiar.addEventListener("click", this.copiarCodigo.bind(this));
    // Escape cierra aunque el foco haya quedado fuera del pop-up (el del tema solo escucha adentro)
    document.addEventListener("keydown", evento => {
      if (evento.key === "Escape" && this.hasAttribute("open")) this.hide();
    });
  };

  P.show = function (opener) {
    this.classList.add("matho-f15--visto");
    mostrarTema.call(this, opener);
    if (!this.contains(document.activeElement)) enfocar(this.dialogHolder);
  };

  P.hide = function () {
    if (!this.hasAttribute("open")) return;
    if (!this.mathoOk && !Shopify.designMode) setCookie("newsletter-closed", "true", DIAS_CERRADO);
    ocultarTema.call(this);
  };

  P.onSubscribe = function () {
    // El formulario sigue solo (POST y recarga): se anota que salio de este pop-up
    marcarEnvio();
  };

  P.connectedCallback = function () {
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") this.show();
      return;
    }
    const estado = this.estadoEnvio();
    if (estado === "ok") return this.mostrarCodigo();
    if (estado === "error") {
      borrarEnvio();
      this.show();
      enfocarAlCargar(this, this.form.querySelector('input[type="email"]'));
      return;
    }
    if (hayEnvio()) return;  // envio en curso (por ejemplo la verificacion anti-spam de Shopify): no molestar
    if (new URLSearchParams(location.search).get("customer_posted") === "true") return;  // se suscribio por otro formulario
    if (!navigator.cookieEnabled) return;
    this.handlePopupVisibility();
  };

  // Se abre cuando pasaron los segundos del setting Y la persona ya se movio por la pagina (ver arriba, SEO).
  // Si esta escribiendo en un campo (el buscador, por ejemplo), espera a que salga. Si hay otra capa abierta
  // (carrito lateral, compra rapida, shop the look, menu, buscador, filtros, pais), no se le abre encima: espera a
  // que se cierre y a que la persona se vuelva a mover (verificacion 22/9: se abria encima del carrito y del menu).
  const MOVERSE = ["wheel", "touchmove", "keydown"];
  const CAPAS = "cart-drawer.is-visible, quick-cart-drawer.is--open, shop-the-look-drawer.is--open, details.drawer__container[open], modal-dialog[open]";
  const otraCapa = () => {
    const b = document.body;
    return b.classList.contains("overflow-hidden") || b.classList.contains("drawer--is-open") || b.style.overflow === "hidden"
      || !!document.querySelector(CAPAS);
  };
  P.showPopupWithDelay = function () {
    let tiempo = false;
    let interaccion = false;
    const escribiendo = () => {
      const a = document.activeElement;
      return !!(a && a !== document.body && !this.contains(a) && a.closest("input, textarea, select, [contenteditable]"));
    };
    const quitar = () => {
      MOVERSE.forEach(ev => removeEventListener(ev, alMoverse, true));
      removeEventListener("pointerdown", alTocar, true);
    };
    const abrir = () => {
      if (!tiempo || !interaccion || escribiendo() || otraCapa() || this.hasAttribute("open")) return;
      quitar();
      if (this.closed !== "true" && this.subscribed !== "true") this.show();
    };
    const alMoverse = () => { interaccion = true; abrir(); };
    const alTocar = () => { interaccion = true; };
    MOVERSE.forEach(ev => addEventListener(ev, alMoverse, { capture: true, passive: true }));
    addEventListener("pointerdown", alTocar, { capture: true, passive: true });
    setTimeout(() => { tiempo = true; abrir(); }, this.delay);
  };

  P.estadoEnvio = function () {
    if (!this.form) return null;
    if (!hayEnvio() && location.hash !== "#" + this.form.id) return null;
    if (new URLSearchParams(location.search).get("customer_posted") === "true") return "ok";
    const campo = this.form.querySelector(".newsletter__field.has-error");
    if (!campo) return null;
    const mensaje = (campo.querySelector("[data-message]") || {}).textContent || "";
    // Si Shopify contesta que el email ya esta registrado, igual le corresponde el codigo
    return /taken|already|exist/i.test(mensaje) ? "ok" : "error";
  };

  P.mostrarCodigo = function () {
    this.mathoOk = true;
    borrarEnvio();
    setCookie("newsletter-subscribed", "true", DIAS_SUSCRIPTO);
    if (!this.panelOk) return;
    this.classList.add("matho-f15--ok");
    this.panelOk.hidden = false;
    // lo que queda oculto no tiene que recibir el foco (el ciclo del Tab del tema cuenta todo lo activo)
    this.querySelectorAll(".newsletter-popup__form input, .newsletter-popup__form button, .js-button-close")
      .forEach(el => { el.disabled = true; });
    this.panelOk.querySelectorAll("button").forEach(el => { el.disabled = false; });
    const titulo = this.panelOk.querySelector("h4[id]");
    if (titulo) this.dialogHolder.setAttribute("aria-labelledby", titulo.id);
    this.show();
    enfocarAlCargar(this, this.panelOk.querySelector("[data-matho-f15-copiar]"));
  };

  P.copiarCodigo = function (evento) {
    const boton = evento.currentTarget;
    const codigo = boton.dataset.codigo || "";
    const aviso = this.querySelector("[data-matho-f15-aviso]");
    const original = boton.dataset.textoOriginal || boton.textContent;
    boton.dataset.textoOriginal = original;
    const listo = () => {
      boton.textContent = "Copied";
      if (aviso) aviso.textContent = "Code " + codigo + " copied";
      clearTimeout(this.mathoCopiado);
      this.mathoCopiado = setTimeout(() => {
        boton.textContent = original;
        if (aviso) aviso.textContent = "";
      }, 2500);
    };
    const planB = () => {
      // sin permiso para el portapapeles: se selecciona el codigo y se intenta copiar
      let ok = false;
      try {
        const rango = document.createRange();
        rango.selectNodeContents(this.querySelector("[data-matho-f15-valor]"));
        const seleccion = window.getSelection();
        seleccion.removeAllRanges();
        seleccion.addRange(rango);
        ok = document.execCommand("copy");
      } catch (e) {}
      if (ok) listo();
      else if (aviso) aviso.textContent = "Select the code to copy it";
    };
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(codigo).then(listo, planB);
    else planB();
  };
})();
/* === MATHO first15 FIN === */
customElements.define("newsletter-popup", NewsletterPopup);
